import React from "react";
import styled from "styled-components";

const Input = styled.input`
  background: transparent;
  margin: 12px 0;
  min-height: 48px;
  padding: 4px 8px;
  color: white;
  font-family: "Roboto Mono", monospace;
  width: 100%;
  box-sizing: border-box;
`;

export default Input;
export function InputWithLabel({ label, ...props }) {
  return (
    <>
      <label>{label}</label>
      <Input {...props} />
    </>
  );
}
